import { useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chevronForwardOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';
import '../pages/Main.css'; 

  
const ContentView : React.FC<ContentInterface> = ({ content }) => {
    
    const router = useIonRouter();

    return (
        <div>
        </div>
    );
};
  
export default ContentView;